import React from "react";
import { getIipayFasciaLabel } from "../utils/iipayFascia";

export const IipayFasciaDetails = ({ row }) => {
  const label = getIipayFasciaLabel(row);
  if (!label) return null;
  const period = String(row.iipay_periodo_riferimento || "");
  const month = /^\d{6}$/.test(period) ? `${period.slice(4)}/${period.slice(0, 4)}` : null;
  const count = row.iipay_cedolini_riferimento;
  const reference = month
    ? `${month} · ${count == null ? "cedolini non disponibili" : `${Number(count).toLocaleString("it-IT")} cedolini`}`
    : "Mese e cedolini non disponibili";
  return <span className="inline-flex items-center justify-center whitespace-nowrap rounded border border-blue-200 bg-blue-50 px-1.5 py-0.5 text-[10px] font-semibold text-blue-700">
    A fascia {label} · {reference}
  </span>;
};
